export const environment = {
  production: false,
  apiUrl: 'https://chatbotpezeta.azurewebsites.net',
  meta: {
    appId: '1326988771817103',
    configurationId: '994167753036585',
    graphVersion: 'v22.0'
  }
};